import { datadogRum } from '@datadog/browser-rum';

export const reportErrorToDatadog = (error: unknown, context?: object) => {
  datadogRum.addError(error, context);
};
